import React from 'react';

const ViolationCategoriesLoading = ({ label }) => (
  <li className="p2"><p className="ml3 mb0 pl1 gray-2">{label}</p></li>
);

ViolationCategoriesLoading.defaultProps = {
  label: 'Loading'
};

export default ViolationCategoriesLoading;
